import { Button } from "@/components/ui/button";
import { ScrollArea } from "@/components/ui/scroll-area";
import { useReactFlow } from '@xyflow/react';

const equipmentCategories = [
  {
    name: "Toestellen",
    items: [
      { id: "brug", name: "Brug", icon: "/lovable-uploads/351ddf3e-2847-477a-b4d5-5a049f472dbc.png", isImage: true },
      { id: "brug-ongelijk", name: "Brug Ongelijk", icon: "/lovable-uploads/b5e493f6-16b8-4ed4-aebe-6e256f5af85b.png", isImage: true },
      { id: "balk", name: "Balk", icon: "/lovable-uploads/d93ec886-3e15-48b4-bc27-0da9ad450ab5.png", isImage: true },
      { id: "rekstok", name: "Rekstok", icon: "/lovable-uploads/aa0ff36c-5b2d-49c7-8c43-b30b5489cd67.png", isImage: true },
      { id: "pegasus", name: "Pegasus", icon: "/lovable-uploads/c0e7787a-b626-4c05-8bde-a22a37e1b47b.png", isImage: true },
      { id: "ringen", name: "Ringen", icon: "/lovable-uploads/23037c2f-da44-4208-bc1b-4f042cb133d6.png", isImage: true },
      { id: "ringen-stil", name: "Ringen Stil", icon: "/lovable-uploads/fa3bda5e-2d0f-4840-aeb4-c69797c2f195.png", isImage: true },
      { id: "voltige", name: "Voltige", icon: "/lovable-uploads/bd1d5ccf-2a67-4c36-8ddb-24314d14884f.png", isImage: true },
      { id: "touwen", name: "Touwen", icon: "/lovable-uploads/cfffcb90-2240-4550-a128-e724f482c307.png", isImage: true },
      { id: "trampoline", name: "Trampoline", icon: "/lovable-uploads/520ce3a0-3fa5-413a-baca-9e01e6127d0a.png", isImage: true },
      { id: "vloer", name: "Vloer", icon: "/lovable-uploads/e95a96dd-9e74-404c-b7eb-37033338bce3.png", isImage: true },
      { id: "bok", name: "Bok", icon: "/lovable-uploads/b9656737-d7d4-41b6-9d3e-a170803e02cf.png", isImage: true },
      { id: "wandrek", name: "Wandrek", icon: "/lovable-uploads/e1ebd36c-a031-4668-83b4-6e6dba55aa4b.png", isImage: true },
      { id: "airbeam", name: "Airbeam", icon: "/lovable-uploads/14297593-fc39-4c33-b424-5f7f13b7a085.png", isImage: true },
      { id: "airtrack", name: "Airtrack", icon: "/lovable-uploads/176c20c7-ad13-461b-a2ac-96cd166b5a27.png", isImage: true },
      { id: "minitrampoline", name: "Minitrampoline", icon: "/lovable-uploads/8c998a1d-c799-406a-a474-dab0662ed8ef.png", isImage: true },
    ]
  },
  {
    name: "Matten",
    items: [
      { id: "landingsmat", name: "Dikke Mat", icon: "/lovable-uploads/cd574a8d-2514-4e8e-939f-713db9eb4e13.png", isImage: true },
      { id: "turnmat", name: "Turnmat", icon: "/lovable-uploads/004486db-eb53-44e0-9104-36e387588f13.png", isImage: true },
      { id: "lange-mat", name: "Lange Mat", icon: "/lovable-uploads/01489ddc-5123-4968-8d71-4e50eb7ad454.png", isImage: true },
      { id: "veiligheidsmatje", name: "Veiligheidsmatje", icon: "/lovable-uploads/b4100312-0e55-456c-b1b2-66f8ca1fc013.png", isImage: true },
    ]
  },
  {
    name: "Hulpmiddelen",
    items: [
      { id: "blok", name: "Blok", icon: "■" },
      { id: "bank", name: "Bank", icon: "/lovable-uploads/3d21e6b2-8499-4006-8e1b-39b28ffe8a84.png", isImage: true },
      { id: "kast", name: "Kast", icon: "/lovable-uploads/4791007d-e7c3-4011-8417-44de78b055fa.png", isImage: true },
      { id: "valkuil", name: "Valkuil", icon: "▣" },
      { id: "bok-hulp", name: "Bok", icon: "/lovable-uploads/4bebbcab-6204-42c0-b68a-48564cbe298a.png", isImage: true },
      { id: "hoepel", name: "Hoepel", icon: "/lovable-uploads/d7c0c556-28fc-4f1f-92ac-8566378b5cda.png", isImage: true },
      { id: "hoepel-2", name: "Hoepel 2", icon: "/lovable-uploads/e595845f-a979-49a1-9689-cb00a8814421.png", isImage: true },
      { id: "paddenstoel", name: "Paddenstoel", icon: "/lovable-uploads/44e19624-c0c9-4a41-9680-2130084309b3.png", isImage: true },
      { id: "flikflakker", name: "Flikflakker", icon: "/lovable-uploads/c9c9e7d9-f7a6-4249-a5fa-065bb8b5e9c9.png", isImage: true },
      { id: "bal", name: "Bal", icon: "/lovable-uploads/746c926c-703f-4d84-98b6-4bf1bd346afa.png", isImage: true },
      { id: "pion-rood", name: "Pion Rood", icon: "/lovable-uploads/89c4e170-a097-4049-87d7-e15372291cd4.png", isImage: true },
      { id: "pion-oranje", name: "Pion Oranje", icon: "/lovable-uploads/fbd661dc-35c0-43c2-a022-0773e67ac6c0.png", isImage: true },
      { id: "plank", name: "Plank", icon: "/lovable-uploads/dd883078-782c-4301-aca8-d66bc3952226.png", isImage: true },
      { id: "plankoline-jf", name: "Plankoline - JF", icon: "/lovable-uploads/6badff69-ff2e-46be-9960-c7ec00a86d7d.png", isImage: true },
    ]
  },
  {
    name: "Leiding",
    items: [
      { id: "turncoach", name: "Turncoach", icon: "👨‍🏫" },
      { id: "assistent", name: "Assistent", icon: "👥" },
    ]
  },
  {
    name: "Toestelcombinaties",
    items: [
      { id: "rekstok-combi", name: "Rekstok", icon: "/lovable-uploads/098e15fd-80c9-4ee2-b72c-5322a13419b7.png", isImage: true },
      { id: "wandrek-combi", name: "Wandrek", icon: "/lovable-uploads/1233daf2-487e-4c35-9d70-27c4d3f10bd8.png", isImage: true },
      { id: "borstwaartsom", name: "Borstwaartsom", icon: "/lovable-uploads/908ae14c-aac4-434f-82d3-6457383e99d1.png", isImage: true },
      { id: "borstwaartsom-2", name: "Borstwaartsom #2", icon: "/lovable-uploads/93034840-0500-4b4a-aba5-4160c80765c5.png", isImage: true },
      { id: "borstwaartsom-3", name: "Borstwaartsom #3", icon: "/lovable-uploads/8e70bc19-dd51-4ea1-9793-19046a464125.png", isImage: true },
      { id: "brug-matjes", name: "Brug met matjes", icon: "/lovable-uploads/d689ea31-86e0-44a7-9118-842d9ab5a042.png", isImage: true },
    ]
  },
  {
    name: "Lesopstellingen",
    items: [
      { id: "touwzwaaien", name: "Touwzwaaien", icon: "/lovable-uploads/56d416e0-7b4d-4023-a585-e71c23089004.png", isImage: true },
      { id: "salto-vo", name: "Salto v.o.", icon: "/lovable-uploads/99ab4762-2825-4b39-b091-f7d85d137027.png", isImage: true },
      { id: "salto-2", name: "Salto #2", icon: "/lovable-uploads/8107c1ad-bdd3-42f5-bc24-eb59ee183076.png", isImage: true },
      { id: "salto-3", name: "Salto #3", icon: "/lovable-uploads/9de0676e-40b1-41b2-ad57-519b7082f042.png", isImage: true },
      { id: "salto-4", name: "Salto #4", icon: "/lovable-uploads/830d35fd-0839-4a1c-acd6-5d1f41fa5882.png", isImage: true },
      { id: "borstwaartsom-les", name: "Borstwaartsom", icon: "/lovable-uploads/9e3dfbbe-205a-46ce-8aab-c5a8bcfda446.png", isImage: true },
    ]
  },
  {
    name: "Tekenen",
    items: [
      { id: "tekst", name: "Tekst", icon: "T", color: "#000000", text: "Typ hier..." },
      { id: "rechthoek", name: "Rechthoek", icon: "▭", color: "#000000", filled: false },
      { id: "rechthoek-gevuld", name: "Rechthoek Gevuld", icon: "▬", color: "#000000", filled: true },
      { id: "vierkant", name: "Vierkant", icon: "■", color: "#000000", filled: true },
      { id: "vierkant-outline", name: "Vierkant Outline", icon: "□", color: "#000000", filled: false },
      { id: "cirkel", name: "Cirkel", icon: "●", color: "#000000", filled: true },
      { id: "cirkel-outline", name: "Cirkel Outline", icon: "○", color: "#000000", filled: false },
      { id: "lijn", name: "Lijn", icon: "─", color: "#000000" },
      { id: "pijl", name: "Pijl", icon: "➜", color: "#000000" },
      { id: "stippellijn", name: "Stippellijn", icon: "┄", color: "#000000" },
    ]
  },
  {
    name: "Gymzalen",
    items: [
      { id: "gymzaal-1", name: "Gymzaal #1", icon: "/lovable-uploads/50d11955-7c6d-44d5-a72a-7e5978a08984.png", isImage: true },
      { id: "gymzaal-2", name: "Gymzaal #2", icon: "/lovable-uploads/45792f6f-4ccc-4d3f-8a15-98e1cfb0b0f8.png", isImage: true },
      { id: "gymzaal-3", name: "Gymzaal #3", icon: "/lovable-uploads/5782003d-fbd8-484f-8d4d-e93ec7ea7ad4.png", isImage: true },
      { id: "gymzaal-4", name: "Gymzaal #4", icon: "/lovable-uploads/ef6ca626-fb73-42ac-8195-6ac5e834fee3.png", isImage: true },
    ]
  }
];

const EquipmentLibrary = () => {
  const reactFlowInstance = useReactFlow();

  const addNodeToFlow = (item: any, position = { x: 100, y: 100 }) => {
    const newNode = {
      id: `${item.id}-${Date.now()}`,
      type: 'equipment',
      position,
      data: { 
        icon: item.icon,
        rotation: 0,
        name: item.name,
        isImage: item.isImage,
        color: item.color,
        flipX: false,
        flipY: false,
        text: item.text,
        id: item.id
      },
      style: { 
        width: item.id === 'tekst' ? 200 : 100, 
        height: item.id === 'tekst' ? 50 : 100,
        background: 'transparent'
      }
    };

    reactFlowInstance.addNodes(newNode);
  };

  const onDragStart = (event: React.DragEvent, item: any) => {
    const preview = document.createElement('img');
    preview.src = item.isImage ? item.icon : 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-size="24" fill="${item.color || 'currentColor'}">${item.icon}</text></svg>`);
    preview.style.width = '40px';
    preview.style.height = '40px';
    preview.style.objectFit = 'contain';
    preview.style.position = 'absolute';
    preview.style.left = '-9999px';
    preview.style.top = '-9999px';
    
    document.body.appendChild(preview);
    
    event.dataTransfer.setDragImage(preview, 20, 20);
    event.dataTransfer.setData('application/reactflow', JSON.stringify(item));
    event.dataTransfer.effectAllowed = 'move';
    
    setTimeout(() => {
      document.body.removeChild(preview);
    }, 0);
  };

  return (
    <div className="p-4">
      {equipmentCategories.map((category) => (
        <div key={category.name} className="mb-6">
          <h3 className="text-sm font-medium mb-3">{category.name}</h3>
          <div className="grid grid-cols-2 gap-2">
            {category.items.map((item) => (
              <Button
                key={item.id}
                variant="outline"
                className="h-20 flex flex-col items-center justify-center gap-2"
                draggable
                onDragStart={(e) => onDragStart(e, item)}
                onClick={() => addNodeToFlow(item)}
              >
                {item.isImage ? (
                  <img 
                    src={item.icon} 
                    alt={item.name}
                    className="w-8 h-8 object-contain"
                  />
                ) : (
                  <span className="text-2xl" style={{ color: item.color }}>{item.icon}</span>
                )}
                <span className="text-xs">{item.name}</span>
              </Button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default EquipmentLibrary;
